﻿$.fn.dxCtrlGridAdresseEmailBounce = function custom_dxCtrlGridAdresseEmailBounce(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridadresseemailbounce dx-ctrl");
        this.createInstance(new cdxCtrlGridAdresseEmailBounce(this, option));
    }
    return this;
}

window.cdxCtrlGridAdresseEmailBounce = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "gridbouncegeneralemail"

    var dxGrid = null
    function mConstruit() {
        container.empty();

        container.css("height", "100%")

        var lstField = mGetLstField()
        var opt = {
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun email en bounce",
            typeData: "lstbounceadresseemail",
            lstTypeGrille: ["Lignes"],
            getItemTemplateHeight: function (typeGrille) { return ((typeGrille == "Lignes") ? 55 : 121) },
            lstLstConditionBase: option.lstLstConditionBase,
            context_grid: option.context_grid,
            itemTemplateGrille: itemTemplateGrille,
            itemTemplateGrillePlus: itemTemplateGrillePlus,
            //nomTemplateIco:"email_bounce",
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                if (typeof dataTemplate.strcon == 'undefined') {
                    //pas de strcon, on affiche un message
                    mNotify("Ce mail n'est lié à aucune fiche", "warning", 3000)
                } else {
                    //on affiche le strcon
                    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table)
                    option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id).mShowPopup()
                }
            },
            onEndClickDataGrid: option.onEndClickDataGrid,
            fields: lstField,
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: false,
            allowToolbar: option.allowToolbar,
            allowDeleteInToolbar: false,
            showColumnHeaders: option.showColumnHeaders,
            lstIdTableIdExclu: option.lstIdTableIdExclu,
            lstIdTableIdInclu: option.lstIdTableIdInclu
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid(opt).dxCtrlVirtualGrid("instance")
    }

    function itemTemplateGrille(contentElement, dataTemplate, type) {
        var $Table = $("<table style='width:100%;height:100%;table-layout:fixed;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdAdresseEmail = $("<td style='width:30%;padding:0 3px;white-space:nowrap;font-family:barlow condensed;text-overflow:ellipsis;overflow:hidden;' class='state-hover2'><u style='width:100%;'>" + dataTemplate.email_bounce.adresse_email + "</u></td>").appendTo($Tr)
        var typeBounce = ""
        var color = ""
        var fontWeight = "normal"
        switch (parseInt(dataTemplate.email_bounce.type_erreur)) {
            case 0:
                typeBounce = "SOFT BOUNCE"
                color = "orange"
                break;
            case 1:
                typeBounce = "HARD BOUNCE"
                color = "red"
                break;
            case 2:
                typeBounce = "MIS EN SPAM"
                color = "red"
                fontWeight = "bold"
                break;
        }
        $("<div style='border-radius:5px;white-space:nowrap;padding:0 5px;width:80px;text-align:center;font-weight:" + fontWeight + ";background-color:" + color + ";'>" + typeBounce + "</div>").appendTo($TdAdresseEmail)
        $TdAdresseEmail.attr("title", dataTemplate.email_bounce.adresse_email + "<br/>" + dataTemplate.email_bounce.message_diag + "<br/>Cliquez pour afficher le détail")
        $TdAdresseEmail.on("click", function (e) {
            e.stopPropagation()
            var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
                fullScreen: false,
                height: "auto",
                width: 500,
                title: typeBounce + " &bull; " + dataTemplate.email_bounce.adresse_email,
                showMaximize: false,
                contentTemplate: function (contentElement) { contentElement.text(dataTemplate.email_bounce.message_diag) }
            }).dxCtrlPopupBase("instance")
            pop.show()
        })


        var $TdStrCon = $("<td style='padding:0 5px;width:70%;'/>").appendTo($Tr)
        if (typeof dataTemplate.strcon == "undefined") {
            $TdStrCon.html("<span style='opacity:0.3;'>Aucune fiche pour l'adresse email</span>")
        } else {
            $TdStrCon.addClass('state-hover2')
            if (dataTemplate.strcon.id_historique_sup) $TdStrCon.css({
                "text-decoration": "line-through",
                "opacity":"0.3"
            })
            var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
            var obj = option.bddCtrl.getObjet(table.nom)
            var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($TdStrCon)
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdICone = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            obj.mGetIcone(dataTemplate.strcon).appendTo($TdICone)
            var $TdImage = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdImage).dxCtrlImgSimpleStrConUti({
                bddCtrl: option.bddCtrl,
                idTable: table.id_table,
                id: dataTemplate.strcon.id_key,
                dataTemplate: dataTemplate,
                text: ""
            })
            var lib = obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon)
            var $TdLib = $("<td style='width:100%;padding:0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;'/>").appendTo($Tr).text(lib)

            $TdStrCon.attr("title", "Ouvrir la fiche<br/>" + lib)
            $TdStrCon.on("click", function (e) { e.stopPropagation(); option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id_key).mShowPopup() })
        }

        //var $TdStrCon = $("<td style='width:100%;text-align:left;padding-left:5px;'/>").appendTo($Tr)
        //if (typeof dataTemplate.strcon == "undefined") {
        //    $TdStrCon.html("<span style='opacity:0.3;'>Aucune fiche pour l'adresse email en erreur</span>")
        //} else {
        //    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
        //    var obj = option.bddCtrl.getObjet(table.nom)
        //    obj.itemTemplateGrille($TdStrCon, dataTemplate.strcon, type)
        //}
    }
    function itemTemplateGrillePlus(contentElement, dataTemplate) {
        var $Span = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataTemplate.email_bounce.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        $Span.attr("title", dataTemplate.email_bounce.dcr.toFrenchDateTime())
    }

    function mGetLstField() {

        var lst = []

        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date erreur",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Erreur: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            groupIndex: 0,
            sortOrder: "desc",
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            dataType: "date",
            allowGrid: true,
            visible: false
        }])
        lst = lst.concat([{
            name: "adresse_email",
            dataField: "adresse_email",
            caption: "Adresse email",
            icon: "fas fa-at",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: false,
            allowSorting: true,
            dataType: "string"
        }, {
            name: "type_erreur",
            dataField: "type_erreur",
            caption: "Type d'erreur",
            icon: "fas fa-ghost",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                var value = "Soft bounce"
                if (options.displayValue == 1) { value = "Hard bounce" }
                else if (options.displayValue == 2) { value = "Mis en SPAM" }
                columnElement.html("<i class='fas fa-ghost dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Type de bounce: " + value + " (" + tot + ")")
            },
            filterProperty: {
                filterOperations: ["parmi", "noparmi"],
                lookup: {
                    dataSource: [{
                        nom: "Soft bounce",
                        id: 0
                    }, {
                        nom: "Hard bounce",
                        id: 1
                    }, {
                        nom: "Mis en SPAM",
                        id: 2
                    }],
                    displayExpr: "nom",
                    valueExpr: "id",
                    placeholder: "Choisissez les types d'erreur"
                }
            }
        }])

        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []

        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-bars-staggered",
                    icon2: "fas fa-ellipsis",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    hint: "Afficher la grille structures/contacts des fiches en bounce",
                    onClick: function (e) {
                        var xlstIdTableId = ""
                        dxGrid.mGetLstTraitementData().forEach(function (dataGrid) {
                            xlstIdTableId += ((xlstIdTableId.length > 0) ? "," : "") + dataGrid.id
                        })
                        if (xlstIdTableId.length > 0) {
                            //option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lst", sql: "select distinct champ_table_email.id_table,champ_table_email.id from email_bounce INNER JOIN champ_table_email ON champ_table_email.valeur=email_bounce.adresse_email where id_email_bounce in (" + xlstIdTableId + ")" }, function (data)
                            option.bddCtrl.mAjaxCall({ command: "getdatasemailbounce", lstid: xlstIdTableId }, function (data) {
                                data.lstemailbounce = JSON.parse(data.lstemailbounce)
                                //if (typeof data.lstemailbounce == 'undefined') data.lstemailbounce = []
                                if (data.lstemailbounce.length > 0) {
                                    page.mAddPopupLst("Liste des bounces emails" + ((typeof option.data == 'undefined') ? "" : " &bull; " + option.data.objet), function (contentElement) {
                                        $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                            bddCtrl: option.bddCtrl,
                                            lstIdTableIdInclu: data.lstemailbounce
                                        })
                                    })
                                } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                            })
                        } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                    }
                }).dxCtrlButton("instance")
            }
        })
        //if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-envelope",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                txtTooltip: "Nouvel email",
        //                onClick: function (e) {
        //                    option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail()
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-square-envelope",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                txtTooltip: "Nouvel emailing",
        //                onClick: function (e) {
        //                    option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail(true)
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //    items.push({
        //        location: 'before',
        //        template: function (itemData, itemIndex, itemElement) {
        //            dxBtNewDocEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-file",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                icon3: "fas fa-at",
        //                colorIcone3: theme.color,
        //                leftIcone3: true,
        //                txtTooltip: "Nouveau document email",
        //                onClick: function (e) {
        //                    (new cObjetFichierEmlzMetier(null, option.bddCtrl)).mShowNewDocumentEmail()
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //}
        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {

    }

    this.mChangeLstIdTableIdExclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdExclu(lstId)
    }
    this.mChangeLstIdTableIdInclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdInclu(lstId)
    }

    this.element = function () { return container }

    mConstruit();
}